import PropTypes from "prop-types";

import { properties as readItemProperties } from "@api/services/investments/ReadInvestmentOutputShape";
import { properties as indexItemProperties } from "@api/services/investments/IndexMyInvestmentsOutputShape";
import { properties as entityShapeProperties } from "@api/services/investments/shapes/EntityShape";

const ProfileEntityShape = PropTypes.exact({
  ...entityShapeProperties,
  _shouldProvideEin: PropTypes.bool,
  _shouldProvideBeneficialOwnerEin: PropTypes.bool,
});

const ReadInvestmentItemShape = PropTypes.exact({
  ...readItemProperties,
  profileEntity: ProfileEntityShape,
});

const IndexInvestmentsItemShape = PropTypes.exact({
  ...indexItemProperties,
  profileEntity: ProfileEntityShape,
});

const InvestmentShape = PropTypes.oneOfType([
  ReadInvestmentItemShape,
  IndexInvestmentsItemShape,
]);

export default InvestmentShape;
